import { ApiPathOption, API_PATHS } from '../types/api-paths';
import { Environment } from '@lx/shared/types';

export function getApiFromEnvironment(environment: Environment): ApiPathOption {
  return API_PATHS[environment];
}
